<template>
  <div class="wrap" >
        <grid-ssp  :item="obj" ></grid-ssp>
  </div>
</template>

<script>
import gridSsp from '@/views/common/grid-ssp'
import { getAction, postAction } from '@/api/manage'
export default {
  components: {
    gridSsp,
  },
  data() {
    return {
      list: [],
      obj:{},
    }
  },
  created() {
    let item =  this.$store.state.ssbView;
    this.obj = {...item};
    console.log(this.obj);
  },
  methods: {

    getData() {
      this.onRefresh()
    },
    matchType(fileName) {
      // 后缀获取
      var suffix = ''
      // 获取类型结果
      var result = ''
      try {
        var flieArr = fileName.split('.')
        suffix = flieArr[flieArr.length - 1]
      } catch (err) {
        suffix = ''
      }
      // fileName无后缀返回 false
      if (!suffix) {
        result = false
        return result
      }
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      // 进行图片匹配
      result = imglist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'image'
        return result
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'amr']
      result = videolist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'video'
        return result
      }
      // 匹配 音频
      var radiolist = ['mp3', 'wav', 'wmv']
      result = radiolist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'radio'
        return result
      }
      // 其他 文件类型
      result = 'other'
      return result
    },
    convert(list) {
      var newList = list.map((val) => {
        var imgList = []
        var videoList = []
        var audioList = []
        if (val.fj && val.fj.length > 0) {
          let arr = val.fj.split(',')
          for (var i = 0; i < arr.length; i++) {
            var path = arr[i]
            if (this.matchType(path) == 'image') {
              imgList.push(path)
            } else if (this.matchType(path) == 'video') {
              videoList.push(path)
            } else if (this.matchType(path) == 'radio') {
              audioList.push(path)
            }
          }
        }
        val.delFlag = 'N'
        val.imgList = imgList
        val.videoList = videoList
        val.audioList = audioList

        return val
      })
      return newList
    },
  },
}
</script>

<style lang="less" scoped>
.wrap{
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f5f5f5;
  padding-top: 0;
}

.top{
  height: 40px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  background: #1989fa;
  line-height: 40px;
  text-align: center;
  color: #FFF;
}


::v-deep .van-pull-refresh {
   min-height:calc(100vh)
}
</style>
